const CustomDiv = ({ key = '', className, style = '', children }) => {
    return(
        <div key={key} className={className} style={{style}}>
            {children}
        </div>
    );
}

export default CustomDiv;